'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCard = function IoCard(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.8 7.5c1.3 0 2.2 0.9 2.2 2.2v20.6c0 1.3-0.9 2.2-2.2 2.2h-30.6c-1.3 0-2.2-0.9-2.2-2.2v-20.6c0-1.3 0.9-2.2 2.2-2.2h30.6z m-29.3 2.5c-0.5 0-0.9 0.4-1 0.9v1.6h30v-1.6c-0.1-0.5-0.5-0.9-1-0.9h-28z m28 20c0.5 0 0.9-0.4 1-0.9v-9.1h-30v9.1c0.1 0.5 0.5 0.9 1 0.9h28z m-26.5-5v-1.2h15v1.2h-15z m0 2.5v-1.2h7.5v1.2h-7.5z m20 0v-3.7h5v3.7h-5z' })
        )
    );
};

exports.default = IoCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/card.js
// module id = 2004
// module chunks = 0